module.exports = __webpack_public_path__ + "img/tamam.6cb5f4ac.svg";